module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"notice_detail":"查看公告详情"}}')
  delete Component.options._Ctor
}
